export default __webpack_public_path__ + "static/media/395.c33a6b2d.png";